const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken?.startsWith("pk_test_")) return null;

  return (
    <div className="w-full bg-orange-500/15 border-b border-orange-500/30 px-4 py-1.5 text-center text-xs text-orange-300">
      Modo prueba: usá la tarjeta <span className="font-mono font-semibold">4242 4242 4242 4242</span> con cualquier fecha futura y CVC.
    </div>
  );
}
